// Filter bar (templates/_partials/_filterBar.twig, ADR 0016): dropdown filter groups, sort, search, active-filter pills.
// Desktop: each group is a dropdown; changes apply with "Apply" (or at once in live mode and for sort), Esc or a click
// outside discards them. Phones: the groups sit in a bottom sheet opened by "Filters".
// submit mode reloads with clean params (?category=a,b&sort=oldest&q=…, back to page 1). live mode updates the URL in
// place and emits `filterbar:change` ({ state }) on the form for the page to filter itself (GalleryFilter.js); the page
// reports back with form.filterBar.setCount() and setOptionCount().
(function() {
    var phone = window.matchMedia('(max-width: 767px)');

    function FilterBar(form) {
        var self = this;
        this.form = form;
        this.live = form.getAttribute('data-filterbar') === 'live';
        this.dropdowns = Array.prototype.slice.call(form.querySelectorAll('[data-dropdown]'));
        this.inputs = Array.prototype.slice.call(form.querySelectorAll('[data-dropdown] input'));
        this.search = form.querySelector('[data-filterbar-search]');
        this.toggle = form.querySelector('[data-filterbar-toggle]');
        this.backdrop = form.nextElementSibling && form.nextElementSibling.hasAttribute('data-filterbar-backdrop') ? form.nextElementSibling : null;
        this.open = null;       // the open dropdown, or 'sheet'
        this.snapshot = null;   // checked inputs when it opened, restored on cancel
        form.filterBar = this;

        this.dropdowns.forEach(function(dropdown) {
            dropdown.querySelector('[data-dropdown-trigger]').addEventListener('click', function() {
                self.open === dropdown ? self.close(false) : self.openDropdown(dropdown);
            });
            var clear = dropdown.querySelector('[data-dropdown-clear]');
            if ( clear ) {
                clear.addEventListener('click', function() {
                    self.inputsOf(dropdown).forEach(function(input) { input.checked = false; });
                    self.live ? self.update() : self.commit();
                });
            }
            var apply = dropdown.querySelector('[data-dropdown-apply]');
            if ( apply ) {
                apply.addEventListener('click', function() { self.commit(); });
            }
            dropdown.addEventListener('change', function(event) {
                // Live mode filters as you tick; a single choice (sort) applies at once from its dropdown.
                if ( self.live ) {
                    self.update();
                } else if ( event.target.type === 'radio' && self.open !== 'sheet' ) {
                    self.commit();
                } else {
                    self.render();
                }
            });
        });

        if ( this.toggle ) {
            this.toggle.addEventListener('click', function() { self.openSheet(); });
        }
        form.querySelectorAll('[data-filterbar-close]').forEach(function(button) {
            button.addEventListener('click', function() { self.close(false); });
        });
        form.querySelectorAll('[data-filterbar-done]').forEach(function(button) {
            button.addEventListener('click', function() { self.commit(); });
        });
        form.querySelectorAll('[data-filterbar-clear-all]').forEach(function(button) {
            button.addEventListener('click', function() { self.clearAll(); });
        });
        form.querySelector('[data-filterbar-pills]').addEventListener('click', function(event) {
            var pill = event.target.closest('[data-pill]');
            if ( !pill ) {
                return;
            }
            if ( pill.getAttribute('data-pill') === 'search' ) {
                self.search.value = '';
            } else {
                self.inputs[+pill.getAttribute('data-pill')].checked = false;
            }
            self.commit();
        });
        if ( this.backdrop ) {
            this.backdrop.addEventListener('click', function() { self.close(false); });
        }
        form.addEventListener('submit', function(event) {
            event.preventDefault();
            self.commit();
        });
        document.addEventListener('click', function(event) {
            if ( self.open && self.open !== 'sheet' && !self.open.contains(event.target) ) {
                self.close(false);
            }
        });
        document.addEventListener('keydown', function(event) {
            if ( event.key === 'Escape' && self.open ) {
                var trigger = self.open === 'sheet' ? self.toggle : self.open.querySelector('[data-dropdown-trigger]');
                self.close(false);
                trigger.focus();
            }
        });
        phone.addEventListener('change', function() { self.close(false); });

        if ( this.live ) {
            this.readUrl();
            this.emit(false);
        }
        this.render();
    }

    FilterBar.prototype.inputsOf = function(dropdown) {
        return Array.prototype.slice.call(dropdown.querySelectorAll('input'));
    };

    FilterBar.prototype.isSort = function(input) {
        return input.name.slice(-2) !== '[]';
    };

    // { key: [values] } for groups; { sort: 'value' } and { q: 'text' } when set.
    FilterBar.prototype.state = function() {
        var state = {};
        this.inputs.forEach(function(input) {
            var key = input.name.replace(/\[\]$/, '');
            if ( input.name.slice(-2) === '[]' ) {
                state[key] = state[key] || [];
                if ( input.checked ) {
                    state[key].push(input.value);
                }
            } else if ( input.checked && input.value ) {
                state[key] = input.value;
            }
        });
        if ( this.search && this.search.value.trim() ) {
            state[this.search.name] = this.search.value.trim();
        }
        return state;
    };

    FilterBar.prototype.url = function() {
        var state = this.state();
        var url = new URL(this.form.action, window.location.href);
        var ours = this.inputs.map(function(input) { return input.name.replace(/\[\]$/, ''); });
        if ( this.search ) {
            ours.push(this.search.name);
        }
        // Keep unrelated params (utm_*, etc.) and replace ours; the action drops /pN, so a new filter starts at page 1.
        new URLSearchParams(window.location.search).forEach(function(value, key) {
            if ( ours.indexOf(key.replace(/\[\]$/, '')) === -1 ) {
                url.searchParams.append(key, value);
            }
        });
        Object.keys(state).forEach(function(key) {
            var value = Array.isArray(state[key]) ? state[key].join(',') : state[key];
            if ( value ) {
                url.searchParams.set(key, value);
            }
        });
        return url;
    };

    // Live mode: the page may be template-cached, so the state comes from the URL (?key=a,b or key[]=a&key[]=b).
    FilterBar.prototype.readUrl = function() {
        var params = new URLSearchParams(window.location.search);
        this.inputs.forEach(function(input) {
            var key = input.name.replace(/\[\]$/, '');
            var values = params.getAll(key + '[]').concat((params.get(key) || '').split(',')).filter(Boolean);
            input.checked = input.value ? values.indexOf(input.value) > -1 : values.length === 0;
        });
    };

    FilterBar.prototype.emit = function(updateUrl) {
        if ( updateUrl ) {
            window.history.replaceState(null, '', this.url());
        }
        this.form.dispatchEvent(new CustomEvent('filterbar:change', { detail: { state: this.state() } }));
    };

    // Live mode: apply the current inputs without closing anything.
    FilterBar.prototype.update = function() {
        this.emit(true);
        this.render();
    };

    FilterBar.prototype.commit = function() {
        this.snapshot = null;
        if ( this.live ) {
            this.close(true);
            this.emit(true);
            this.render();
        } else {
            this.form.classList.add('is-loading');
            window.location.assign(this.url());
        }
    };

    FilterBar.prototype.clearAll = function() {
        var self = this;
        this.inputs.forEach(function(input) {
            input.checked = self.isSort(input) ? input.value === '' : false;
        });
        if ( this.search ) {
            this.search.value = '';
        }
        this.commit();
    };

    FilterBar.prototype.remember = function() {
        this.snapshot = this.inputs.map(function(input) { return input.checked; });
    };

    FilterBar.prototype.restore = function() {
        var snapshot = this.snapshot;
        if ( snapshot ) {
            this.inputs.forEach(function(input, i) { input.checked = snapshot[i]; });
        }
        this.snapshot = null;
    };

    FilterBar.prototype.openDropdown = function(dropdown) {
        this.close(false);
        this.open = dropdown;
        this.remember();
        dropdown.classList.add('is-open');
        dropdown.querySelector('[data-dropdown-trigger]').setAttribute('aria-expanded', 'true');
        var first = dropdown.querySelector('input:checked') || dropdown.querySelector('input');
        if ( first ) {
            first.focus({ preventScroll: true });
        }
    };

    FilterBar.prototype.openSheet = function() {
        this.close(false);
        this.open = 'sheet';
        this.remember();
        this.form.classList.add('is-sheet-open');
        document.documentElement.classList.add('has-sheet-open');
        this.toggle.setAttribute('aria-expanded', 'true');
        if ( this.backdrop ) {
            this.backdrop.hidden = false;
        }
        this.form.querySelector('[data-filterbar-close]').focus();
    };

    // applied: the changes were committed (otherwise they are discarded; in live mode they already applied).
    FilterBar.prototype.close = function(applied) {
        if ( !this.open ) {
            return;
        }
        if ( !applied && !this.live ) {
            this.restore();
        }
        if ( this.open === 'sheet' ) {
            this.form.classList.remove('is-sheet-open');
            document.documentElement.classList.remove('has-sheet-open');
            this.toggle.setAttribute('aria-expanded', 'false');
            if ( this.backdrop ) {
                this.backdrop.hidden = true;
            }
        } else {
            this.open.classList.remove('is-open');
            this.open.querySelector('[data-dropdown-trigger]').setAttribute('aria-expanded', 'false');
        }
        this.open = null;
        this.render();
    };

    // Trigger labels, the active-filter pills, the badge and "Clear all".
    FilterBar.prototype.render = function() {
        var self = this;
        var pills = [];
        var active = 0;
        this.dropdowns.forEach(function(dropdown) {
            var checked = self.inputsOf(dropdown).filter(function(input) { return input.checked && input.value; });
            var value = dropdown.querySelector('[data-dropdown-value]');
            if ( dropdown.hasAttribute('data-sort') ) {
                var current = dropdown.querySelector('input:checked') || self.inputsOf(dropdown)[0];
                value.textContent = current ? current.getAttribute('data-label') : '';
                dropdown.classList.toggle('is-active', checked.length > 0);
                return;
            }
            value.textContent = checked.length === 0 ? 'Any' : (checked.length === 1 ? checked[0].getAttribute('data-label') : checked.length + ' selected');
            dropdown.classList.toggle('is-active', checked.length > 0);
            active += checked.length;
            checked.forEach(function(input) {
                pills.push({ index: self.inputs.indexOf(input), label: input.getAttribute('data-label') });
            });
        });
        if ( this.search && this.search.value.trim() && !this.live ) {
            pills.unshift({ index: 'search', label: '“' + this.search.value.trim() + '”' });
        }

        var list = this.form.querySelector('[data-filterbar-pills]');
        list.innerHTML = '';
        pills.forEach(function(pill) {
            var li = document.createElement('li');
            var button = document.createElement('button');
            button.type = 'button';
            button.className = 'ds-filterbar__pill';
            button.setAttribute('data-pill', pill.index);
            button.setAttribute('aria-label', 'Remove filter: ' + pill.label);
            button.textContent = pill.label;
            button.insertAdjacentHTML('beforeend', '<svg viewBox="0 0 16 16" width="12" height="12" aria-hidden="true"><path d="M4 4l8 8M12 4l-8 8" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>');
            li.appendChild(button);
            list.appendChild(li);
        });
        this.form.querySelectorAll('.ds-filterbar__summary [data-filterbar-clear-all]').forEach(function(button) {
            button.hidden = pills.length === 0;
        });
        var badge = this.form.querySelector('[data-filterbar-badge]');
        if ( badge ) {
            badge.hidden = active === 0;
            badge.textContent = active;
        }
    };

    // For live pages: the result count text, and an option's count under the other active filters.
    FilterBar.prototype.setCount = function(text) {
        this.form.querySelector('[data-filterbar-count]').textContent = text;
        this.form.querySelectorAll('[data-filterbar-done]').forEach(function(button) {
            button.textContent = 'Show ' + text;
        });
    };

    FilterBar.prototype.setOptionCount = function(input, count) {
        var label = input.closest('.ds-option');
        var counter = label.querySelector('[data-option-count]');
        if ( counter ) {
            counter.textContent = count;
        }
        label.classList.toggle('is-empty', count === 0 && !input.checked);
    };

    document.addEventListener('DOMContentLoaded', function() {
        document.querySelectorAll('[data-filterbar]').forEach(function(form) {
            new FilterBar(form);
        });
    });
})();
